import { render, staticRenderFns } from "./QScoreCardTotalRecruits.vue?vue&type=template&id=474402aa&scoped=true&"
import script from "./QScoreCardTotalRecruits.vue?vue&type=script&lang=js&"
export * from "./QScoreCardTotalRecruits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474402aa",
  null
  
)

export default component.exports